module.exports = __webpack_public_path__ + "static/media/BG_6.edd43e87.png";